import { render, staticRenderFns } from "./puntos.vue?vue&type=template&id=ba87c288&"
import script from "./puntos.vue?vue&type=script&lang=js&"
export * from "./puntos.vue?vue&type=script&lang=js&"
import style0 from "./puntos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports